import type { SyncAmsState } from '../../hooks/useAmsSync';

export type AmsSyncStatusIconKind = 'success' | 'warning' | 'error';

/**
 * Maps AMS sync state to the status icon severity used in Bulk Actuals.
 * Partial sync is a warning (incomplete), not a hard error.
 */
export function getAmsSyncStatusIconKind(
  type: SyncAmsState['type'],
): AmsSyncStatusIconKind {
  switch (type) {
    case 'synced':
      return 'success';
    case 'partially-synced':
      return 'warning';
    case 'not-synced':
      return 'error';
  }
}
